import React from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../styles/utils';

const FooterContainer = styled.footer`
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  padding: ${pxToRem(8)} 0;
  width: 100%;
  position: relative;
  z-index: 1;
`;

const FooterContent = styled.div`
  max-width: ${pxToRem(1200)};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(16)};
  font-size: ${pxToRem(12)};
  color: rgba(102, 102, 102, 0.6);
  white-space: nowrap;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <span>ИП Сычев Евгений Вадимович</span>
        <span>•</span>
        <span>ОГРНИП: 323420500074490</span>
        <span>•</span>
        <span>ИНН: 421415966679</span>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;